import { sha256 } from 'js-sha256';
import log from 'loglevel';
import validateContract from '../../util/validateCM';
import pushGTMEvent from '../../util/helper/pushGTMEvent';
import rules from '../../Action/validations/index';

const configContents = ({
  state: {
    credentials,
    langStrings,
    showForm: { showEnteredCM },
    hasError: {
      authEmail,
      currentCM,
      isBicAsset,
      invalidEmail,
      contractNumberError
    },
    currentCMDetails,
  },
  dispatch,
}) => {
  return [
    {
      isTitle: true,
      description: langStrings
        ? langStrings.processInfoScreen.currentInfoTitle
        : '2. Current Information',
      id: 'adsk-page-title',
    },
    {
      description: langStrings
        ? langStrings.processInfoScreen.contractNumLabel
        : 'Contract number',
      style: { fontWeight: 600 },
      paragraphStyle: { marginBottom: '5px' },
      endWithRedStar: true,
      endWithInfoCircle: true,
      hoverInfoDescriptions: langStrings
        ? langStrings.processInfoScreen.contractNumTooltip
        : 'Find the contract number in the Billing & Orders area in your <a target="_blank" href="https://manage.autodesk.com">Account.</a>',
      id: 'adsktm-cm-label',
    },
    {
      isShown: currentCM,
      description: langStrings
        ? langStrings.errors.enterValidFormat
        : 'Enter a valid format',
      style: { fontWeight: 400, color: '#ec4a41', fontSize: '14px' },
      paragraphStyle: { marginBottom: '5px' },
      id: 'adsktm-contractnum-error',
    },
    {
      isShown: contractNumberError,
      description: langStrings
        ? langStrings.cm.errors.contractNumNotFound
        : 'Contract number not found',
      style: { fontWeight: 400, color: '#ec4a41', fontSize: '14px' },
      paragraphStyle: { marginBottom: '5px' },
      id: 'adsktm-contractnum-not-found-error',
    },
    {
      isMaskInput: true,
      mask: [/\d/, /\d|-/, /\d/, /\d|-/, /\d/,/\d/, /\d/, /\d/, /\d/, /\d/,/\d/, /\d/],
      description: langStrings
      ? langStrings.pv.processInfoScreen.contractNumLabel
      : 'Contract number',
      handleChange: async (e) => {
        try {
          // store CM value char by char.
          dispatch({
            type: 'SET_ENTERED_CM',
            payload: { cmData: e.target.value },
          });

          const cleanValue = e.target.value.replace(/[^\d|-]/g, '');

          // cleanValue !== 12, then remove all errors, and authEmail fields.
          const checkCM = cleanValue !== 12
          if (checkCM) {
            // REMOVE RED BOUNDRY WHEN USER STARTS TYPING.
            dispatch({
              type: 'DISABLE_SHOWN_ERROR',
              payload: { type: 'currentCM', hasError: false },
            });
          }

          if (cleanValue.length === 12) {
            const regex = /^\d{11,12}$|^\d{3}-\d{8}$|^\d{1}[-]\d{10}$/;
            if (cleanValue.match(regex)) {
              // enable loading spinner
              dispatch({
                type: 'MAKE_CM_CALL',
                payload: { loading: true },
              });
              const response = await validateContract(cleanValue, credentials);
              log.debug('Response from cm validations ::: ', response);
              if (response && response.status === 200) {
                if (response.data.isBicAsset) {
                  log.debug('isBicAsset true');
                  dispatch({
                    type: 'IS_BIC_ASSET',
                    payload: true,
                  });
                }
                log.debug('response status ::: ', response.status);
                log.debug('response encryptedEmail ::: ', response.data.encryptedContractManagerEmail);
                const { encryptedContractManagerEmail } = response.data;
                dispatch({
                  type: 'CM_RESPONSE_RECEIVED',
                  payload: {
                    encryptedCMAuthEmail: encryptedContractManagerEmail
                  },
                });
                // disabled checkmark after 1500 ms, once the user entered CM field is verfied.
                setTimeout(()=> {
                  dispatch({ type: 'DISABLE_CHECKMARK'});
                }, 500)
              } else {
                // show field validation error.
                log.debug('response status error::: ', response.status);
                log.debug('response ::: ', response);
                if(response.status === 400 && (
                    response.errors[0].code === 'T-01' ||
                    response.errors[0].code === 'R-01' )
                  ) {
                  // Error: contract number not found!
                  dispatch({ type: 'CONTRACT_NUMBER_ERROR'});
                } else {
                  dispatch({
                    type: 'SHOW_CM_FIELD_VALIDATION',
                    payload: true,
                  });
                }
              }
            } else {
              // enable loading spinner
              dispatch({
                type: 'SHOW_CM_FIELD_VALIDATION',
                payload: true,
              });
            }
          } else {
            // if the user input is not 12 digits.
            dispatch({
              type: 'USER_IS_TYPING_AUTHEMAIL',
              payload: {
                isBicAssetBanner: false, // Make it false.
                currentCMAuthEmailFieldError: false, // Disable CM AuthEmail error if any.
                currentCMAuthEmail: '', // Update state of current CM field to emapty so user can enter again.
              },
            });
          }
        } catch (err) {
          log.debug('Error is : ', err);
        }
      },
      showLoadingSpinner: currentCMDetails.loading,
      value: currentCMDetails.contractNumber,
      id: 'adsktm-contractnum',
      className: 'cm-number',
      showError: currentCM,
      showCheckmark: currentCMDetails.showCheckmark,
    },
    {
      isShown: true,
      description: langStrings
        ? langStrings.processInfoScreen.contractNumDisclaimer
        : 'Include the hyphen (-) if your contract number has one.',
      style: { variant: 'caption' },
      paragraphStyle: {
        margin: '0px 0px 20px',
        fontStyle: 'italic'
      },
    },
    {
      isShown: isBicAsset,
      BGColor: '#f7fcfe',
      BGPadding: '20px 20px 20px',
      description: langStrings
        ? langStrings.processInfoScreen.msgBicIndirectCMRole
        : 'Bic Asset',
      style: {
        color: '#333',
        fontSize: '14px',
        marginbottom: '20px',
      },
      paragraphStyle: { marginBottom: '20px' },
      id: 'adsktm-cm-bic-asset-banner',
    },
    { // clean input value.
    },
    {
      isShown: showEnteredCM,
      description: langStrings
        ? langStrings.cm.processInfoScreen.currentCmEmailLabel
        : 'Current contract manager’s email',
      style: { fontWeight: 600 },
      paragraphStyle: { marginBottom: '5px' },
      endWithRedStar: true,
      id: 'adsktm-cm-auth-email-label',
    },
    {
      isShown: authEmail,
      description: langStrings
        ? langStrings.cm.errors.emailNotAssociatedWithcontractNum
        : `This email isn’t associated with the contract number above.`,
      style: { fontWeight: 400, color: '#ec4a41', fontSize: '14px' },
      paragraphStyle: { marginBottom: '5px' },
      id: 'adsktm-cm-email-error',
    },
    {
      isShown: invalidEmail,
      description: langStrings
        ? langStrings.errors.enterValidFormat
        : 'Enter a valid format',
      style: { fontWeight: 400, color: '#ec4a41', fontSize: '14px' },
      paragraphStyle: { marginBottom: '5px' },
      id: 'adsktm-cm-email-error',
    },
    { // clean input value.
    },
    {
      isShown: showEnteredCM,
      isTextInput: true,
      placeholder: langStrings
        ? langStrings.cm.processInfoScreen.cmEmailPlaceholder
        : 'Associated with the contract number',
      value: currentCMDetails.authEmail,
      isError: authEmail,
      handleValidation: () => {},
      handleSubmit: () => {},
      handleChange: e => {
        let value = e.target.value;
        log.debug('authEmail value is : ', value, rules.authEmail.pattern);
        value = value.trim();
        // convert into lower case
        value = value.toLowerCase();
        const regexEmail = rules.authEmail.pattern;
        log.debug('regex value check : ', value, value.match(regexEmail));
        if (value.match(regexEmail)) {
          if (sha256(value) === currentCMDetails.encryptedCMAuthEmail) {
            log.debug('ELSE SHA256 value ::: ', typeof value, sha256(value));
            dispatch({
              type: 'SET_ENTERED_AUTH_EMAIL',
              payload: {
                userEnteredAuthEmail: value,
                hasAuthError: false,
                hasValidationError: false,
              },
            });
          } else {
            // dispatch error event: Auth Email is not associated with Contract Number.
            log.debug('CM email is but not associated with CM error.');
            dispatch({
              type: 'VALIDATE_AUTH_EMAIL',
              payload: {
                userEnteredAuthEmail: '',
                authEmailError: true,
                isEmailValid: true, // email is valid
              },
            });
          }
        } else if (value !== ''){
          log.debug('dispatching error : Invalid Email format');
          dispatch({
            type: 'AUTH_EMAIL_INVALID_FORMAT',
            payload: {
              userEnteredAuthEmail: '',
              hasError: true,
              hasAuthError: false,
            },
          });
        } else {
          log.debug('Clear error : Invalid Email format');
          dispatch({
            type: 'AUTH_EMAIL_INVALID_FORMAT',
            payload: {
              userEnteredAuthEmail: '',
              hasError: false,
              hasAuthError: false,
            },
          });
        }
      },
      paragraphStyle: { marginBottom: '30px' },
      focusIn: true,
      id: 'current-cm-email',
    },
  ];
};

const configFooter = ({
  state: {
    userSession,
    langStrings,
    hasExtension,
    currentCMDetails,
  },
  dispatch,
}) => ({
  requiredDisclaimer: true,
  hasQuestion: true,
  hasExtension,
  nextButtonContent: langStrings ? langStrings.buttons.nextButton : 'NEXT',
  handleNext: () => {
    pushGTMEvent('NewInfo');
    dispatch({ type: 'GO_TO_NEW_CM_PAGE' });
  },
  handleBack: () => {
    if (userSession)
      pushGTMEvent('ContactInfo');
    else
      pushGTMEvent('Welcome');
      dispatch({ type: 'GO_TO_REVIEW_ACCOUNT_PAGE' });
  },
  handleAgentLoad: () => dispatch({ type: 'AGENT_LOADED' }),
  handleAgentAvailable: (flag) => dispatch({ type: 'AGENT_AVALIABLE', payload: { isAgentAvailable: flag } }),
  handleChatInitialized: () => dispatch({ type: 'AGENT_INITIALIZED' }),
  handleChatStarted: () => dispatch({ type: 'GO_TO_AGENT_AVAILABLE_PAGE' }),
  handleSupportAnalytics: () => pushGTMEvent('ContactSupport'),
  handleAgentAnalytics: () => pushGTMEvent('ChatWithAgent'),
  handleCaseAnalytics: () => pushGTMEvent('CreateCase'),
  handleNextButtonId: 'adsktm-cm-next-button',
  handleBackButtonId: 'adsktm-cm-back-button',
  requiredDisclaimerId: 'adsktm-required-disclaimer-text',
  handleAgentButtonId: 'adsktm-agent-button',
  handleCaseButtonId: 'adsktm-case-button',
  handleQuestionButtonId: 'adsktm-have-question-button',
  // eslint-disable-next-line no-unneeded-ternary
  enableNextButton: currentCMDetails.authEmail ? true : false,
});

export default {
  configContents,
  configFooter,
};
